import {useMemo} from 'react'
import {useQuery} from 'react-query'

import {useVenue} from '../../../api/venue/hooks'
import {OnlinePayability, resolveOnlinePayability} from '../helpers/online-payability'
import {PaymentService} from '../index'

/**
 * Whether the venue in the URL can take money online.
 *
 * Reuses the terminal lookup the pay flow already makes — same query key, same options — so this
 * reads the shared React Query cache entry instead of issuing a second request.
 */
export const useOnlinePayability = () => {
  const {data: venue} = useVenue()
  const venueId = venue?.uid
  const {
    data: terminal,
    status,
    error,
  } = useQuery(
    PaymentService.queries.getTerminalQuery({
      params: {venueId},
      refetchOnWindowFocus: false,
    }),
  )

  return useMemo(() => {
    const payability = resolveOnlinePayability({venueId, status, terminal, error})
    return {
      payability,
      isOnlinePayable: payability === OnlinePayability.AVAILABLE,
      hasNoPaymentTerminal: payability === OnlinePayability.NO_TERMINAL,
    }
  }, [venueId, status, terminal, error])
}
